// utils/createCrudReducer.js
import { createSlice } from "@reduxjs/toolkit";

export const createCrudReducer = (entidade, thunks) => {
  const initialState = {
    [entidade]: [],
    error: null
  };

  return createSlice({
    name: `${entidade}Slice`,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(thunks.get.fulfilled, (state, action) => {
          state[entidade] = action.payload;
        })
        .addCase(thunks.add.fulfilled, (state, action) => {
          state[entidade].push(action.payload);
        })
        .addCase(thunks.update.fulfilled, (state, action) => {
          state[entidade] = state[entidade].map((item) =>
            // item.id.toString() === action.payload.id.toString()
            //   ? { ...item, ...action.payload }
            //   :
               item
          );
        })
        .addCase(thunks.deletar.fulfilled, (state, action) => {
          state[entidade] = state[entidade].filter(
            (item) => item.id.toString() !== action.payload.toString()
          );
        })

        // Error handlers
        .addMatcher(
          (action) => action.type.endsWith('/rejected'),
          (state, action) => {
            state.error = action.error || null;
          }
        );
    },
  }).reducer;
};
